var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'waiting' }}},[_c('i',{staticClass:"el-icon-edit-outline"}),_c('span',[_vm._v("待攻略"+_vm._s(_vm.name))]),(_vm.showCounter)?_c('span',{staticClass:"u-waiting",style:(_vm.waitingColorStyle())},[_vm._v("（"+_vm._s(_vm.solveRate.toFixed(2))+"%）")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }